import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// import TimeField from 'react-simple-timefield';
// import classes from 'classnames';
import 'rc-time-picker/assets/index.css';
import ButtonsBlock from './ButtonsBlock';
import {Button, buttonTypes} from "../../../../../components/Button";
import TP from './TimePicker';
// import TimePicker from 'rc-time-picker';

class CreateEditSlots extends React.Component {
  constructor(props) {
    super(props);
    this.setSelectedDays = this.setSelectedDays.bind(this);
    this.state = {
      selectedDaysIndex: {},
      timeSlots: [],
      error: {}
    }
  }

  static propTypes = {
    usedDays: PropTypes.object,
    nameDays: PropTypes.array,
    selectedDays: PropTypes.object,
    timeSlots: PropTypes.array,
    slotIndex: PropTypes.number,
    save: PropTypes.func,
  };

  componentWillMount() {
    if (this.props.timeSlots.length === 0) {
      this.addTimeSlot();
    } else {
      this.setState({timeSlots: this.props.timeSlots})
    }

    if (this.props.slotIndex || this.props.slotIndex === 0) {
      this.setState({slotIndex: this.props.slotIndex})
    }
    this.setState({selectedDaysIndex: this.props.selectedDays})
  }

  addTimeSlot() {
    const state = {...this.state};
    const {timeSlots} = state;
    let maxId = 0;
    for (let i = 0; i < timeSlots.length; i++) {
      if (+timeSlots[i].id > maxId) {
        maxId = timeSlots[i].id;
      }
    }

    const newTimeSlot = {
      id: maxId + 1,
      startTime: '',
      endTime: ''
    };
    timeSlots.push(newTimeSlot);
    this.setState({timeSlots})
  }

  setSelectedDays(index) {
    const {selectedDaysIndex, error} = this.state;
    if (selectedDaysIndex[index]) {
      delete selectedDaysIndex[index]
    } else {
      selectedDaysIndex[index] = true;
    }
    this.setState({selectedDaysIndex, error: {...error, selectDays: ''}})
  }

  handleChange(e) {
    const {name, value} = e;
    const identifyArr = name.split('-');
    const field = identifyArr[0];
    const id = identifyArr[1];

    const {timeSlots, error} = this.state;

    const updated = timeSlots.map((item) => {
      const event = item;
      if (+event.id === +id) {
        const err = {};

        if (field === 'startTime') {
          event.endTime = moment(value, 'h:mma').add(1, 'hours').format('H:mm');
        }
        err.startTime = '';
        // Validate begin end time
        if (field === 'endTime') {
          const start = moment(moment(event.startTime, 'h:mma').format('h:mma'), 'h:mma');
          const end = moment(moment(value, 'h:mma').format('h:mma'), 'h:mma');
          if (!start.isBefore(end)) {
            err.endTime = 'End time > start time'
          } else {
            err.endTime = '';
          }
        }
        if (field === 'startTime') {
          const start = moment(moment(value, 'h:mma').format('h:mma'), 'h:mma');
          const end = moment(moment(event.endTime, 'h:mma').format('h:mma'), 'h:mma');
          if (!start.isBefore(end)) {
            err.endTime = 'End time > start time'
          } else {
            err.endTime = '';
          }
        }
        this.setState({error: {...error, [id]: {...error[id], ...err}}});

        event[field] = value;
        return event
      }
      return event;
    });

    this.setState({timeSlots: updated});
  }

  deleteSlot(id) {
    const state = {...this.state};
    const {timeSlots} = state;

    for (let i = 0; i < timeSlots.length; i++) {
      if (+timeSlots[i].id === +id) {
        timeSlots.splice(i, 1)
      }
    }
    this.setState({timeSlots});
  }

  checkTimeSlots(slots) {
    const {error} = this.state;
    const result = [];
    let isValid = true;

    for (let i = 0; i < slots.length; i++) {
      const err = {};
      if (slots[i].startTime && slots[i].endTime) {
        // Validate begin end time
        const start = moment(moment(slots[i].startTime, 'h:mma').format('h:mma'), 'h:mma');
        const end = moment(moment(slots[i].endTime, 'h:mma').format('h:mma'), 'h:mma');

        if (!start.isBefore(end)) {
          err.endTime = 'End time > start time';
          isValid = false;
        } else {
          err.endTime = '';
          result.push({
            startTime: slots[i].startTime,
            endTime: slots[i].endTime
          })
        }
        this.setState({error: {...error, [slots[i].id]: {...error[slots[i].id], ...err}}});
      } else {
        isValid = false;
        err.endTime = 'Add Time';
        err.startTime = 'Add time';
        this.setState({error: {...error, [slots[i].id]: {...error[slots[i].id], ...err}}});
      }
    }
    return {result, isValid}
  }

  saveSchedule() {
    const {error} = this.state;
    if (Object.keys(this.state.selectedDaysIndex).length > 0) {
      const validate = this.checkTimeSlots(this.state.timeSlots);
      if (validate.isValid)
        this.props.save({
          selectedDaysIndex: this.state.selectedDaysIndex,
          timeSlots: validate.result,
          slotIndex: this.state.slotIndex
        });
    } else {
      this.setState({error: {...error, selectDays: 'Pleas select days'}});
    }
  }

  render() {
    const {
      nameDays,
      usedDays
    } = this.props;

    const {
      timeSlots,
      selectedDaysIndex,
      error
    } = this.state;

    // const style = {
    //   width: '40px'
    // };

    return (
      <div>
        {error.selectDays ? <span>{error.selectDays}</span> : null}
        <ButtonsBlock
          usedDays={usedDays}
          days={nameDays}
          selectedDays={selectedDaysIndex}
          setSelectedDays={this.setSelectedDays}
        />
        {
          timeSlots.length > 0 ?
            <p className="tour-schedule__timeSlot-title">Please enter Military time</p>
            : null
        }
        {
          timeSlots.map((item) => {
            return (
              <div
                key={`time-slot-${item.id}`}
                className="tour-schedule__dates-time-slot"
              >
                <div className="input-block">
                  <span className="input-block__label">Start at</span>
                  {error[item.id] && error[item.id].startTime ? <span className="error-block">{error[item.id].startTime}</span> : null}
                  <div className="input-block__time">
                    {/* <TimeField
                      style={style}
                      value={item.startTime}
                      onChange={(e) => this.handleChange({
                        name: `startTime-${item.id}`,
                        value: e
                      })}
                    /> */}
                    <TP
                      defaultTime={item.startTime}
                      onNewTime={(e) => this.handleChange({
                        name: `startTime-${item.id}`,
                        value: e
                      })}
                    />
                  </div>
                  {/* <TimePicker
                    allowEmpty={false}
                    showSecond={false}
                    defaultValue={null}
                    value={item.startTime ? moment().hour(item.startTime.split(':')[0]).minute(item.startTime.split(':')[1]) : null}
                    className=""
                    placeholder="Select time"
                    onChange={(e) => this.handleChange({
                      name: `startTime-${item.id}`,
                      value: moment(e).format('HH:mm')
                    })}
                    format="HH:mm"
                    minuteStep={15}
                    inputReadOnly
                  /> */}
                </div>
                <div className="input-block">
                  <span className="input-block__label">End at</span>
                  {error[item.id] && error[item.id].endTime ? <span className="error-block">{error[item.id].endTime}</span> : null}
                  <div className="input-block__time">
                    {/* <TimeField
                      style={style}
                      value={item.endTime}
                      onChange={(e) => this.handleChange({
                        name: `endTime-${item.id}`,
                        value: e
                      })}
                    /> */}
                    <TP
                      defaultTime={item.endTime}
                      onNewTime={(e) => this.handleChange({
                        name: `endTime-${item.id}`,
                        value: e
                      })}
                    />
                  </div>

                  {/* <TimePicker
                    allowEmpty={false}
                    showSecond={false}
                    value={item.endTime ? moment().hour(item.endTime.split(':')[0]).minute(item.endTime.split(':')[1]) : null}
                    className=""
                    placeholder="Select time"
                    onChange={(e) => this.handleChange({
                      name: `endTime-${item.id}`,
                      value: moment(e).format('HH:mm')
                    })}
                    format="HH:mm"
                    minuteStep={15}
                    inputReadOnly
                  /> */}
                </div>
                <Button
                  className="button__icon fa fa-times"
                  onClick={() => this.deleteSlot(item.id)}
                />
              </div>
            )
          })
        }
        <div className="tour-schedule__buttons">
          <div className="tour-schedule__buttons-group">
            <Button
              type={buttonTypes.LINK}
              name="Add Slot"
              onClick={() => this.addTimeSlot()}
            />
            <span className="fa fa-plus" />
          </div>
          <Button
            name="Save"
            onClick={() => this.saveSchedule()}
          />
        </div>
      </div>
    )
  }
}

export default CreateEditSlots;


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/Tour/components/TimeSlots/CreateEdit.js